import { useLocalStorage } from 'react-use';

/** Handle boolean localStorage values for the `useLocalStorage` hook */
export const localStorageBooleanSerializer: Extract<
  Parameters<typeof useLocalStorage<boolean>>[2],
  { raw: false }
> = {
  raw: false,
  serializer: (value: boolean) => (value ? 'true' : 'false'),
  deserializer: (value: unknown) => value === 'true',
};

/** Handle string array localStorage values for the `useLocalStorage` hook */
export const localStorageStringArraySerializer: Extract<
  Parameters<typeof useLocalStorage<string[]>>[2],
  { raw: false }
> = {
  raw: false,
  serializer: (value: string[]) => JSON.stringify(value),
  deserializer: (value: unknown) => {
    try {
      const parsed = JSON.parse(value as string);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  },
};
